const dailyTaskRoutes = {
  path: 'daily-task',
  name: 'dailyTask',
  component: { template: '<router-view></router-view>' },
  // 保留故障和工作日志详情中已有的日常任务入口。
  redirect: { name: 'dailyTaskList' },
  children: [
    {
      path: 'list',
      name: 'dailyTaskList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '日常任务',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default dailyTaskRoutes;
